import { styled } from '@mui/material';

export const InfoList = styled('ul')({
  listStyleType: 'none',
  padding: 0,
  margin: 0,
  marginTop: '20px',
  fontSize: '14px',
  '& > li': {
    display: 'flex',
    alignItems: 'center',
    margin: '10px 0',
    '& > label': {
      fontWeight: 500,
      width: '70px',
      textAlign: 'right',
      marginRight: '6px'
    }
  }
});
